export const theme = {
  primaryDark: '#1b1b1b',
  primaryDarkWithOpacity: 'rgba(27, 27, 27, 0.8)',
  primaryWhite: '#ffffff',
  primaryGray: '#f3f3f3',
  accent: '#084c90',
  transition: '250ms cubic-bezier(0.4, 0, 0.2, 1)',
};
